import { render } from "./CharlaQA.vue?vue&type=template&id=3b2cc0ae&scoped=true"
import script from "./CharlaQA.vue?vue&type=script&lang=js"
export * from "./CharlaQA.vue?vue&type=script&lang=js"

import "./CharlaQA.vue?vue&type=style&index=0&id=3b2cc0ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2cc0ae"]])

export default __exports__